class ProfileStorage {
  private static STORAGE_PREFIX = "profile."

  static getItem(key: string): string | null {
    return localStorage.getItem(this.STORAGE_PREFIX + key)
  }

  static setItem(key: string, value: string): void {
    localStorage.setItem(this.STORAGE_PREFIX + key, value)
  }
}

export class HowToTapStorage {
  private static KEY = "howToTap.seen"

  static hasBeenViewed(): boolean {
    return ProfileStorage.getItem(this.KEY) === "true"
  }

  static markAsViewed(): void {
    ProfileStorage.setItem(this.KEY, "true")
  }
}
